module.exports = __webpack_public_path__ + "img/icon-farmstarV3.a4709e96.svg";